import React, {useEffect} from 'react'
import Aboutsect1 from './Aboutsect1';
import Aboutsect2 from './Aboutsect2';
import Aboutcompany from './Aboutcompany';
import Aboutbreadcrumbs from './Aboutbreadcrumbs';
import CompanyMilestones from './CompanyMilestones';
import CompanyMilestone1 from './CompanyMilestone1';
import Testimonials from './Testimonials'


function About() {
  // This will help prevent multiple registrations of the same constraint
  useEffect(() => {
    // If you have access to the regula object from the core.min.js
    // You can add this code to fix the constraint conflict
    if (window.regula && typeof window.regula.override === 'function') {
      try {
        window.regula.override({
          constraint: "PhoneNumber",
          // Copy the original constraint configuration here
          // Or just provide a minimal viable configuration
          params: ["format"],
          defaultMessage: "Invalid phone number format",
          validator: function(params) {
            // Basic phone validation or leave empty if you want to use the original validator
            return true;
          }
        });
      } catch (e) {
        console.log("Regula override failed, but it's okay:", e);
      }
    }
    
    // Initialize any scripts that need to run after component mounts
    if (window.jQuery) {
      // Initialize any jQuery plugins or components here
    }
  }, []); // Empty dependency array ensures this runs only once

  return (
    <div>

      <div className="page">
       
        
        
        
        {/* Breadcrumbs */}
        <section className="breadcrumbs-custom-inset">
          <div className="breadcrumbs-custom context-dark bg-overlay-46">
            <div className="container">
              <h2 className="breadcrumbs-custom-title">About Our Company</h2>
              <ul className="breadcrumbs-custom-path">
                <li><a href="index.html">Home</a></li>
                <li className="active">About Us</li>
              </ul>
            </div>
            <div className="box-position" style={{backgroundImage:"url(assets/images/bannerabout1.png)"}}></div>
          </div>
        </section>

  
    
        

         {/* Why choose us */}
    
         <section>
        <Aboutcompany/>
      </section>


      

         {/* What people say */}
         

      
      <section>
        <Aboutsect1/>
      </section>

     

      
        
        {/* Main Content Sections */}
        {/* Why choose us section, Our History section, etc. */}
        {/* ... (rest of your content) ... */}
        <section>
          <CompanyMilestone1/>
        </section>

        <section>
          <Testimonials />
        </section>


        
      </div>
      
      {/* Global Mailform Output */}
      <div className="snackbars" id="form-output-global"></div>
    </div>
  );
}

export default About;
